module.exports = "/_next/static/images/Destinations@2x-e1a2e4640c18b230f8c9a4549660abe9.png";